// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"d6dc9353","408":"ae2323a3","878":"ca323186"}[chunkId] + ".chunk.js";
};